module.exports = new __parcel__URL__("C7O2.2fb30cb2.png").toString();